import { isMobile } from 'react-device-detect'
import HeaderLogoSmall from './HeaderLogoSmall'
import HeaderLogo from './HeaderLogo'

const HeaderLogoDevice = () => {
  return isMobile ? <HeaderLogoSmall /> : <HeaderLogo />
}

export default HeaderLogoDevice
